export default {
  title: 'Mediasbox',
  description: 'Gérez vos fichiers et médias',
  analytics: {
    title: 'Analytique de l\'asset',
  },
  workspaces: {
    title: 'Espaces de travail',
    spaces: 'espaces',
    create: 'Créer un espace',
    search: 'Rechercher des espaces...',
    toggleCompact: 'Basculer en vue compacte',
    expand: 'Développer la barre latérale',
    
    // Storage
    storage: 'Utilisation du stockage',
    storageInfo: 'Vidéos comptées en heures • Autres fichiers en Go',
    details: 'Détails',
    videoStorage: 'Stockage vidéo',
    otherStorage: 'Autres fichiers',
    globalUsage: 'Utilisation globale',
    includingRenditions: 'incluant toutes les qualités',
    videoEquivalent: '~{size} de stockage',
    good: 'Bon',
    high: 'Élevé',
    critical: 'Critique',
    storageGood: 'Bon',
    storageHigh: 'Élevé',
    storageCritical: 'Critique',
    storageDetails: 'Détails du stockage',
    overallUsage: 'Utilisation globale',
    totalStorage: 'Stockage total',
    usedStorage: 'Stockage utilisé',
    availableStorage: 'Disponible',
    storageCriticalMessage: 'Vous manquez d\'espace de stockage !',
    storageHighMessage: 'Votre stockage est presque plein.',
    upgradePlan: 'Améliorer le plan',
    byFileType: 'Par type de fichier',
    topWorkspaces: 'Principaux espaces',
    
    // Navigation
    overview: 'Vue d\'ensemble',
    favorites: 'Favoris',
    recent: 'Récents',
    all: 'Tous les espaces',
    searchResults: 'Résultats de recherche',
    
    // Stats
    empty: 'Vide',
    file: 'fichier',
    files: 'fichiers',
    oneFile: '1 fichier',
    multipleFiles: '{count} fichiers',
    used: 'Utilisé',
    
    // Actions
    favorite: 'Ajouter aux favoris',
    unfavorite: 'Retirer des favoris',
    pin: 'Épingler l\'espace',
    unpin: 'Désépingler l\'espace',
    pinned: 'Épinglé',
    shared: 'Espace partagé',
    private: 'Espace privé',
    moreActions: 'Plus d\'actions',
    edit: 'Modifier l\'espace',
    duplicate: 'Dupliquer',
    share: 'Partager',
    export: 'Exporter',
    archive: 'Archiver',
    unarchive: 'Désarchiver',
    delete: 'Supprimer',
    
    // Time
    justNow: 'À l\'instant',
    minutesAgo: 'Il y a {n}m',
    hoursAgo: 'Il y a {n}h',
    daysAgo: 'Il y a {n}j',
    
    // Empty state
    emptyState: {
      title: 'Aucun espace de travail',
      description: 'Créez votre premier espace pour commencer à organiser vos fichiers',
      action: 'Créer le premier espace'
    },
    
    // Search
    noResults: 'Aucun espace trouvé pour "{query}"',
    
    // File types
    videos: 'Vidéos',
    images: 'Images',
    documents: 'Documents',
    audio: 'Audio',
    other: 'Autre',
    
    // Storage Details Dialog
    storageExplanation: 'Le stockage vidéo est mesuré en heures pour inclure toutes les qualités. Les autres fichiers sont mesurés en Go.',
    videoStorageTitle: 'Stockage Vidéo',
    otherFilesTitle: 'Stockage Autres Fichiers',
    ofVideo: 'de vidéo',
    totalDuration: 'Durée totale',
    estimatedSize: 'Utilisation disque estimée',
    videoCount: 'Fichiers vidéo',
    renditions: 'Qualités de rendu',
    included: 'Incluses',
    fileDistribution: 'Répartition par type',
    workspaceBreakdown: 'Répartition par espace',
    byVideoDuration: 'Par durée vidéo',
    byStorageSize: 'Par taille de stockage'
  },
  upload: {
    button: 'Téléverser',
    dragDrop: 'Glissez-déposez les fichiers ici',
    or: 'ou',
    browse: 'Parcourir les fichiers',
    uploading: 'Téléversement...',
    success: 'Fichier téléversé avec succès',
    error: 'Échec du téléversement'
  },
  file: {
    name: 'Nom',
    size: 'Taille',
    type: 'Type',
    modified: 'Modifié',
    created: 'Créé',
    actions: 'Actions',
    download: 'Télécharger',
    rename: 'Renommer',
    move: 'Déplacer',
    copy: 'Copier',
    share: 'Partager',
    delete: 'Supprimer',
    preview: 'Aperçu',
    info: 'Informations'
  },
  move: {
    title: 'Déplacer {count} élément | Déplacer {count} éléments',
    currentLocation: 'Emplacement actuel',
    action: 'Déplacer',
    success: '{count} élément déplacé avec succès | {count} éléments déplacés avec succès',
    error: 'Échec du déplacement des éléments'
  },
  folder: {
    create: 'Nouveau dossier',
    name: 'Nom du dossier',
    empty: 'Ce dossier est vide',
    root: 'Racine',
    path: 'Chemin',
    enterName: 'Entrez le nom du dossier',
    items: 'élément | éléments'
  },
  createFolder: 'Créer un dossier',
  createFolderDescription: 'Organiser vos fichiers',
  createCollection: 'Créer une collection',
  createCollectionDescription: 'Grouper des fichiers liés',
  uploadFile: 'Téléverser des fichiers',
  uploadFileDescription: 'Ajouter du nouveau contenu',
  workspace: {
    select: 'Sélectionner l\'espace de travail'
  },
  types: {
    folder: 'Dossier',
    file: 'Fichier',
    video: 'Vidéo',
    image: 'Image',
    audio: 'Audio',
    document: 'Document',
    archive: 'Archive',
    collection: 'Collection',
    other: 'Autre'
  },
  search: {
    placeholder: 'Rechercher des dossiers...',
    placeholderAssets: 'Rechercher des fichiers et dossiers...',
    noResults: 'Aucun résultat trouvé'
  },
  filter: {
    title: 'Filtres',
    type: 'Type de fichier',
    recent: 'Récents',
    favorites: 'Favoris',
    hasMedia: 'Contient des médias',
    empty: 'Dossiers vides',
    clear: 'Tout effacer',
    images: 'Images',
    videos: 'Vidéos',
    documents: 'Documents',
    audio: 'Fichiers audio'
  },
  sort: {
    title: 'Trier par',
    name: 'Nom',
    modified: 'Dernière modification',
    size: 'Nombre d\'éléments'
  },
  space: {
    title: 'Espaces',
    create: 'Créer un espace',
    name: 'Nom de l\'espace',
    description: 'Description',
    defaultSpace: 'Espace par défaut'
  },
  view: {
    grid: 'Vue grille',
    list: 'Vue liste',
    sortBy: 'Trier par',
    filterBy: 'Filtrer par'
  },
  selection: {
    selected: '{count} sélectionné(s)',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Tout désélectionner'
  },
  confirmDelete: {
    title: 'Supprimer {type} ?',
    message: 'Êtes-vous sûr de vouloir supprimer "{name}" ?',
    messageMultiple: 'Êtes-vous sûr de vouloir supprimer {count} éléments ?',
    permanentWarning: 'Cette action est irréversible.'
  },
  select: {
    title: 'Sélectionner un fichier',
    action: 'Sélectionner',
    items: 'élément | éléments',
    emptyFolder: 'Ce dossier est vide',
    preview: 'Aperçu',
    duration: 'Durée'
  },
  video: {
    trim: {
      title: 'Découper la vidéo',
      newLength: 'Nouvelle durée de la vidéo',
      startTime: 'Temps de début',
      endTime: 'Temps de fin',
      setStart: 'Définir le début',
      setEnd: 'Définir la fin',
      reset: 'Réinitialiser'
    },
    capture: {
      title: 'Capturer une image',
      preview: 'Image capturée',
      noCapture: 'Aucune image capturée',
      captureButton: 'Capturer l\'image actuelle',
      format: 'Format d\'image',
      quality: 'Qualité',
      filename: 'Nom du fichier',
      info: '{width}x{height} à {time}'
    }
  },
  settings: {
    foldersDisplay: 'Affichage des dossiers',
    foldersDisplayHint: 'Contrôlez l\'affichage des dossiers dans la vue.',
    flattenFolders: 'Masquer les dossiers (vue plate)'
  }
}
